import { Component } from '@angular/core';

@Component({
	selector: 'ngbd-pagination',
	templateUrl: './popover-tooltip.component.html'
}) 
 
export class NgbdPopTooltip{
  	 name = 'World';
}



// WEBPACK FOOTER //
// ./src/app/pages/component/popover-tooltip/popover-tooltip.component.ts